import { combineReducers } from "redux"

// Front
import Layout from "./layout/reducer"

// Authentication
import Login from "./auth/login/reducer"
import Account from "./auth/register/reducer"
import ForgetPassword from "./auth/forgetpwd/reducer"
import Profile from "./auth/profile/reducer"

//Calendar
import calendar from "./calendar/reducer"

//E-commerce
import ecommerce from "./e-commerce/reducer"

//chat
import chat from "./chat/reducer"

//invoices
import invoices from "./invoices/reducer"

//contacts
import contacts from "./contacts/reducer"
import admins from "./admins/reducer"
import ceremonies from "./ceremony/reducer"
import vendor_cats from "./vendor_cat/reducer"
import vendor from "./vendor/reducer"
import vendor_media from "./vendor_media/reducer"
import vendor_pricing from "./vendor_pricing/reducer"
import vendortypeServices from "./vendor_types_services/reducer"
import vendortypeSettings from "./vendor_types_settings/reducer"
import vendor_event from "./vendor_events/reducer"
import address from "./address/reducer"
import clients from "./clients/reducer"
import purchases from "./purchases/reducer"
import events from "./events/reducer"
import ceremony_pack from "./ceremony-pack/reducer"
import budget_percentage from "./budget-percentage/reducer"
import settings from "./settings/reducer"
import popup from "./popup/reducer"
import howitworks from "./how_it_works/reducer"
import faq from "./faq/reducer"
import reviews from "./reviews/reducer"

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Account,
  ForgetPassword,
  Profile,
  calendar,
  chat,
  ecommerce,
  invoices,
  contacts,
  admins,
  ceremonies,
  vendors: combineReducers({
    vendor_cats,
    vendor,
    vendor_media,
    vendor_pricing,
    vendor_event,
    vendortypeServices,
    vendortypeSettings
  }),
  ceremony: combineReducers({ ceremonies, ceremony_pack }),
  clients,
  purchases,
  events,
  address,
  budget_percentage,
  settings,
  popup,
  howitworks,
  faq,
  reviews
})

export default rootReducer
